import {combineReducers} from "redux";
import ajouterAssignementGroupeCategorieReducer from "./ajouterAssignementGroupeCategorie";
import supprimerAssignementGroupeCategorieReducer from "./supprimerAssignementGroupeCategorie";


export default combineReducers({
    ajouterAssignementGroupeCategorie : ajouterAssignementGroupeCategorieReducer,
    supprimerAssignementGroupeCategorie: supprimerAssignementGroupeCategorieReducer
});